import { useEffect, useState } from "react";

/* Consenso cookie — Linee guida Garante Privacy 10 giugno 2021.
   - "necessari": sempre attivi (archiviazione tecnica).
   - "statistiche" e "terze" (servizi di terze parti non tecnici): solo con consenso esplicito,
     nessuna casella preselezionata, lo scorrimento non vale come consenso.
   - Rifiuto: il banner non viene riproposto per 6 mesi. */
const KEY = "orion-cookie-consent";
const SIX_MONTHS = 182 * 24 * 60 * 60 * 1000;
export const CONSENT_EVENT = "orion-consent-change";
export const OPEN_BANNER_EVENT = "orion-open-cookie-banner";

export function readConsent() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const c = JSON.parse(raw);
    if (c.esito === "rifiutato" && c.expireAt && Date.now() > c.expireAt) {
      localStorage.removeItem(KEY);
      return null;
    }
    return c;
  } catch {
    return null;
  }
}

export function writeConsent(statistiche, terze) {
  const c = {
    necessari: true,
    statistiche: !!statistiche,
    terze: !!terze,
    esito: statistiche || terze ? "accettato" : "rifiutato",
    ts: Date.now(),
    expireAt: statistiche || terze ? null : Date.now() + SIX_MONTHS,
  };
  try {
    localStorage.setItem(KEY, JSON.stringify(c));
  } catch {
    /* storage non disponibile: il banner verrà riproposto */
  }
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: c }));
  return c;
}

export function acceptAllConsent() {
  return writeConsent(true, true);
}

export function refuseConsent() {
  return writeConsent(false, false);
}

/* Riapre il banner dalle preferenze (footer o pagina cookie). */
export function openCookieBanner() {
  window.dispatchEvent(new CustomEvent(OPEN_BANNER_EVENT));
}

/* Stato del consenso, sincronizzato tra componenti (banner, pagina cookie). */
export function useConsent() {
  const [consent, setConsent] = useState(null);
  useEffect(() => {
    const apply = (e) => setConsent((e && e.detail) || readConsent());
    setConsent(readConsent());
    window.addEventListener(CONSENT_EVENT, apply);
    window.addEventListener(OPEN_BANNER_EVENT, apply);
    return () => {
      window.removeEventListener(CONSENT_EVENT, apply);
      window.removeEventListener(OPEN_BANNER_EVENT, apply);
    };
  }, []);
  return consent;
}
